<template>
  <base-list-table :data="data" :structure="structure" :refreshFunction="refreshPage" />
</template>

<script>
  import { useStore } from 'vuex';
  import { computed } from 'vue';
  export default {
    components: {},
    setup() {
      const store = useStore();

      const refreshPage = (payload) => store.dispatch('getManagers', payload);

      const managers = computed(() => store.getters.managers);

      // table
      const structure = {
        title: 'views.managers.title',
        toTranslate: true,
        creationLink: {
          title: 'buttons.createManager',
          toTranslate: true,
          namePath: 'menu.sharing.createManager',
        },
        data: [
          {
            title: 'user.name.first',
            fields: [
              {
                placeholder: '@',
                name: 'id',
                class: 'text-primary-400',
              },
              {
                name: 'name',
              },
            ],
            span: 1,
            link: { idField: 'id', path: '/sharing/managers/:id/' },
          },
          {
            title: 'address.body',
            field: 'address',
            span: 2,
          },
          {
            title: 'user.cellphone',
            field: 'cellphone',
            span: 1,
          },
          {
            title: 'user.email',
            field: 'email',
            span: 1,
          },
          {
            title: 'payments.stripeAccount',
            field: 'stripe_account',
            span: 1,
          },
          {
            title: 'address.zipcode',
            field: 'zipcode',
            span: 1,
          },
        ],
      };
      return {
        data: managers,
        structure,
        refreshPage,
      };
    },
  };
</script>

<style></style>
